import { gameApi as api } from './emptyGameApi';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    autoplayControllerShowCurrentAutoplay: build.query<
      AutoplayControllerShowCurrentAutoplayApiResponse,
      AutoplayControllerShowCurrentAutoplayApiArg
    >({
      query: () => ({ url: `/api/game-api/autoplay/current` }),
    }),
    autoplayControllerDeleteAutoplay: build.mutation<
      AutoplayControllerDeleteAutoplayApiResponse,
      AutoplayControllerDeleteAutoplayApiArg
    >({
      query: () => ({ url: `/api/game-api/autoplay/current`, method: 'DELETE' }),
    }),
    autoplayControllerCreateAutoplay: build.mutation<
      AutoplayControllerCreateAutoplayApiResponse,
      AutoplayControllerCreateAutoplayApiArg
    >({
      query: (queryArg) => ({
        url: `/api/game-api/autoplay`,
        method: 'POST',
        body: queryArg.createAutoplayInputDto,
      }),
    }),
    autoplayControllerStopAutoplay: build.mutation<
      AutoplayControllerStopAutoplayApiResponse,
      AutoplayControllerStopAutoplayApiArg
    >({
      query: () => ({ url: `/api/game-api/autoplay/current/stop`, method: 'POST' }),
    }),
    healthControllerPing: build.query<
      HealthControllerPingApiResponse,
      HealthControllerPingApiArg
    >({
      query: () => ({ url: `/api/health` }),
    }),
    gameControllerGetGamesBetsCount: build.query<
      GameControllerGetGamesBetsCountApiResponse,
      GameControllerGetGamesBetsCountApiArg
    >({
      query: () => ({ url: `/api/game-api/games/bets/count` }),
    }),
    gameControllerGetGamesCountByBet: build.query<
      GameControllerGetGamesCountByBetApiResponse,
      GameControllerGetGamesCountByBetApiArg
    >({
      query: (queryArg) => ({ url: `/api/game-api/games/bets/${queryArg.bet}/count` }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as gameApi };
export type AutoplayControllerShowCurrentAutoplayApiResponse =
  /** status 200  */ ShowCurrentAutoplayOutputDto;
export type AutoplayControllerShowCurrentAutoplayApiArg = void;
export type AutoplayControllerDeleteAutoplayApiResponse = unknown;
export type AutoplayControllerDeleteAutoplayApiArg = void;
export type AutoplayControllerCreateAutoplayApiResponse =
  /** status 200  */ CreateAutoplayOutputDto;
export type AutoplayControllerCreateAutoplayApiArg = {
  createAutoplayInputDto: CreateAutoplayInputDto;
};
export type AutoplayControllerStopAutoplayApiResponse =
  /** status 200  */ ShowCurrentAutoplayOutputDto;
export type AutoplayControllerStopAutoplayApiArg = void;
export type HealthControllerPingApiResponse = unknown;
export type HealthControllerPingApiArg = void;
export type GameControllerGetGamesBetsCountApiResponse =
  /** status 200  */ GamesBetsCountDto;
export type GameControllerGetGamesBetsCountApiArg = void;
export type GameControllerGetGamesCountByBetApiResponse =
  /** status 200  */ GameBetCountDto;
export type GameControllerGetGamesCountByBetApiArg = {
  bet: '0.05' | '0.25' | '0.5';
};
export type ShowCurrentAutoplayOutputDto = {
  autoplayUuid: string;
  playedGamesCount: number;
  requestedGamesCount: number;
  countAfterStopped: number;
  status: 'insufficient_balance' | 'all_games_played' | 'in_progress' | 'stopped';
  bet: '0.05' | '0.25' | '0.5';
  isStopped: boolean;
};
export type CreateAutoplayOutputDto = {
  autoplayUuid: string;
  requestedGamesCount: number;
};
export type CreateAutoplayInputDto = {
  bet: '0.05' | '0.25' | '0.5';
  count: number;
  /** Contains from 0 to 10 elements */
  favouriteNumbers: number[];
};
export type GameBetCountDto = {
  bet: '0.05' | '0.25' | '0.5';
  gamesCount: number;
};
export type GamesBetsCountDto = {
  gamesCount: GameBetCountDto[];
};
export const {
  useAutoplayControllerShowCurrentAutoplayQuery,
  useLazyAutoplayControllerShowCurrentAutoplayQuery,
  useAutoplayControllerDeleteAutoplayMutation,
  useAutoplayControllerCreateAutoplayMutation,
  useAutoplayControllerStopAutoplayMutation,
  useHealthControllerPingQuery,
  useLazyHealthControllerPingQuery,
  useGameControllerGetGamesBetsCountQuery,
  useLazyGameControllerGetGamesBetsCountQuery,
  useGameControllerGetGamesCountByBetQuery,
  useLazyGameControllerGetGamesCountByBetQuery,
} = injectedRtkApi;
